<script setup lang="ts" generic="T extends string | number">
defineProps<{
  id: string;
  label: string;
  options: { value: T; label: string }[];
}>();

const model = defineModel<T>({ required: true });
</script>

<template>
  <label
    :for="id"
    class="bg-carte flex h-[58px] min-w-[150px] cursor-pointer flex-col justify-center gap-[2px] rounded-[20px] px-4 shadow-[inset_0_0_0_1px_var(--pds-filet-fort)] focus-within:shadow-[inset_0_0_0_2px_var(--pds-encre)]"
  >
    <span class="text-encre-douce text-[12px] leading-[14px] font-semibold">
      {{ label }}
    </span>
    <select
      :id="id"
      v-model="model"
      class="text-encre w-full cursor-pointer bg-transparent text-[16px] leading-6 outline-none"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </label>
</template>
